// src/components/Header.js
import React from 'react';

const Header = () => {
  return (
    <header className="bg-[#F6F6F6] flex items-center h-16 px-4 lg:px-10">
      {/* Logo */}
      <div className="flex items-center">
        <a
          href="https://alleanzabrasilcorretora.com.br/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src="/newlogo.png"
            alt="Alleanza"
            className="w-28 h-auto"
          />
        </a>
      </div>

      {/* Menu à direita */}
      <nav className="ml-auto flex space-x-8">
        <a
          href="https://alleanzabrasilcorretora.com.br/"
          className="text-[#224189] font-bold hover:underline"
        >
          Início
        </a>
        <a
          href="https://alleanzabrasilcorretora.com.br/#beneficio"
          className="text-[#224189] font-bold hover:underline"
        >
          Benefícios
        </a>
        <a
          href="https://alleanzabrasilcorretora.com.br/#parceiros"
          className="text-[#224189] font-bold hover:underline"
        >
          Parceiros
        </a>
        <a
          href="https://alleanzabrasilcorretora.com.br/#perguntas"
          className="text-[#224189] font-bold hover:underline"
        >
          Perguntas
        </a>
        <a
          href="https://alleanzabrasilcorretora.com.br/#contato"
          className="text-[#224189] font-bold hover:underline"
        >
          Contato
        </a>
      </nav>
    </header>
  );
};

export default Header;
